import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../../../../types/super-cut-field'
import CaptionPositionField from '../../../../../form-fields/super-cut/caption-position'
import { CreationCaptureInfoContext } from '../manager'
import SuperCutSegmentationType from '../../../../../../types/super-cut-segmentation-type'

const CaptionPosition = styled(CaptionPositionField)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureInfoCaptionPositionField = ({ field }: Props) => {
    const { segmentationType } = useContext(CreationCaptureInfoContext)
    return (
        <>
            {segmentationType === SuperCutSegmentationType.Caption && (
                <CaptionPosition
                    {...{
                        field,
                    }}
                />
            )}
        </>
    )
}

export default CreationCaptureInfoCaptionPositionField
